<template>
  <div>
    <w-tool-tabs class="tab-button" v-model="activeTab">
      <el-tab-pane label="예측 자원 설정" name="WTargetSetting">
        <w-target-setting ref="WTargetSetting" :active-tab="activeTab"/>
      </el-tab-pane>
        <el-tab-pane label="이벤트/알람 설정" name="WEventAlarmSetting">
          <w-event-alarm-setting ref="WEventAlarmSetting" :activeTab="activeTab"/>
        </el-tab-pane>
        <el-tab-pane label="데이터 학습 기간 설정" name="WCustomLearnDataSetting">
          <w-custom-learn-data-setting ref="WCustomLearnDataSetting" :activeTab=" activeTab"/>
        </el-tab-pane>
      </w-tool-tabs>
  </div>
</template>

<script>
import WTargetSetting from './TargetSetting';
import WEventAlarmSetting from './EventAlarmSetting';
import WCustomLearnDataSetting from './CustomLearnDataSetting';

/**
 * 이벤트 예측 설정 화면
 */
export default {
  name: 'WEventPredictView',
  components: {
    WTargetSetting,
    WEventAlarmSetting,
    WCustomLearnDataSetting,
  },
  watch: {
    activeTab() {
      console.log(this.activeTab);
      this.activeTabLoad();
    },
  },
  data() {
    return {
      activeTab: 'WTargetSetting',
    };
  },
  methods: {
    loadData() {
      this.activeTabLoad();
    },
    activeTabLoad() {
      this.$nextTick(() => {
        const activeTab = this.activeTab;
        this.$refs[activeTab].loadData();
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/operation/BasicInfoSettings/EventPredictSetting/EventPredictView.vue